import {useEffect} from 'react'

const useScript = (
  options: {
    id: string
    src?: string
    content?: string
    removeScriptWithId?: string
  },
  apply: boolean = true
) => {
  useEffect(() => {
    if (!window.document) return
    const document = window.document

    const script = document.createElement('script')
    script.setAttribute('id', options.id)

    if (options.src) script.src = options.src
    if (options.content) script.text = options.content
    script.type = 'text/javascript'
    script.async = true

    if (document && !document.getElementById(options.id) && apply)
      document.head.appendChild(script)

    if (!apply && document.getElementById(options.id)) {
      document.getElementById(options.id)?.remove()
      ;(window as any)[options.id] = {}
    }

    if (!apply && options.removeScriptWithId) {
      document.getElementById(options.removeScriptWithId)?.remove()
    }
  }, [options, apply])
}
export {useScript}
